var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "49px",
    viewBox: "0 0 60 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03AEB3A7-C682-4D15-ADA1-72A0E4ABD7BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEATHER-CHANGES",
    transform: "translate(-117.000000, -105.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bars-regular",
    transform: "translate(117.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.19565217 C0,1.42472826 1.43303571,0 3.21428571,0 L56.7857143,0 C58.5669643,0 60,1.42472826 60,3.19565217 C60,4.96657609 58.5669643,6.39130435 56.7857143,6.39130435 L3.21428571,6.39130435 C1.43303571,6.39130435 0,4.96657609 0,3.19565217 Z M0,24.5 C0,22.7290761 1.43303571,21.3043478 3.21428571,21.3043478 L56.7857143,21.3043478 C58.5669643,21.3043478 60,22.7290761 60,24.5 C60,26.2709239 58.5669643,27.6956522 56.7857143,27.6956522 L3.21428571,27.6956522 C1.43303571,27.6956522 0,26.2709239 0,24.5 Z M60,45.8043478 C60,47.5752717 58.5669643,49 56.7857143,49 L3.21428571,49 C1.43303571,49 0,47.5752717 0,45.8043478 C0,44.0334239 1.43303571,42.6086957 3.21428571,42.6086957 L56.7857143,42.6086957 C58.5669643,42.6086957 60,44.0334239 60,45.8043478 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconWhite);
export default __webpack_public_path__ + "static/media/menuIconWhite.960794d8921c96e598a2aab2bb2ae077.svg";
export { ForwardRef as ReactComponent };